import axios from "axios";
import jwt_decode from "jwt-decode";

// Set base URL based on environment
let baseURL;
if (process.env.NODE_ENV === "development") {
  baseURL = "http://127.0.0.1:8002/api";
  // baseURL = "https://kodinyumba.app/api";
} else {
  baseURL = "https://kodinyumba.app/api";
}

// Create Axios instance
export const serverUrl = axios.create({
  baseURL: baseURL,
});

// Global 401 interceptor - clears token and redirects to login on any unauthorized response
serverUrl.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("authTokens");
      window.location.replace("/#/login");
    }
    return Promise.reject(error);
  }
);

// Export base URL
export const baseUrl = baseURL;

const getStoredAuthTokens = () => {
  const selectedUserToken = localStorage.getItem("authTokens");
  if (!selectedUserToken) {
    return null;
  }

  try {
    return JSON.parse(selectedUserToken);
  } catch (error) {
    localStorage.removeItem("authTokens");
    return null;
  }
};

export const getAccessToken = () => {
  const authTokens = getStoredAuthTokens();
  if (!authTokens?.access) {
    return null;
  }
  return authTokens.access;
};

// Create Axios/fetch config with authorization header
export const getConfig = () => {
  const accessToken = getAccessToken();
  if (!accessToken) {
    return {};
  }

  return {
    headers: { Authorization: `Bearer ${accessToken}` },
  };
};

// Decode the JWT token to get user ID
export const getUserIdFromToken = () => {
  const accessToken = getAccessToken();
  if (!accessToken) {
    return null;
  }
  try {
    const decodedToken = jwt_decode(accessToken);
    return decodedToken.user_id;
  } catch (error) {
    localStorage.removeItem("authTokens");
    return null;
  }
};

// Fetch landlord IDs for the current user
export const fetchLandlordIds = async () => {
  try {
    const userId = getUserIdFromToken();
    if (!userId) {
      return null;
    }

    const config = getConfig();
    const response = await serverUrl.get(`/landlord/landlord/?user_id=${userId}`, config);
    const landlordIds = response.data.results[0].id;
    return landlordIds;
  } catch (error) {
    console.error("Error fetching landlord IDs:", error);
    throw error;
  }
};
